export const TRY_PIPELINES_LINK =
  'https://www.jetbrains.com/teamcity/download/?utm_source=product&utm_medium=link&utm_campaign=TC&utm_content=teamcity-pipelines#section=saas'
export const PIPELINES_INFO_PAGE =
  'https://www.jetbrains.com/teamcity/pipelines/?utm_source=product&utm_medium=link&utm_campaign=TC&utm_content=teamcity-pipelines'
